import { ApolloCache, Reference } from "@apollo/client";
import {
  ArchivedPostTemplateResponseFragment,
  PostTemplateStatusEnum,
} from "generated/schemaTypes";

export const removePostTemplateFromCurrentCachedList = ({
  cache,
  postTemplate,
  status,
}: {
  cache: ApolloCache<unknown>;
  postTemplate: ArchivedPostTemplateResponseFragment;
  status: PostTemplateStatusEnum;
}) => {
  cache.modify({
    id: cache.identify({ ...postTemplate.organization }),
    fields: {
      postTemplates(existingPostTemplates, { readField, storeFieldName }) {
        if (storeFieldName.includes(`"status":"${status}"`)) {
          return existingPostTemplates.filter(
            (templateRef: Reference) =>
              readField("id", templateRef) !== postTemplate.id
          );
        }
        return existingPostTemplates;
      },
    },
  });
};
